import React, { useMemo, useEffect } from 'react';
import { API_URL } from '../config';

function AuctionWinnerOverlay({ auction, user, onClose }) {
  const pieces = useMemo(() => (
    Array.from({ length: 48 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 0.8,
      duration: 2.4 + Math.random() * 1.8,
      rotate: Math.random() * 360,
      color: ['#ffd700', '#ff6b35', '#22c55e', '#fff', '#70a1ff'][i % 5]
    }))
  ), []);

  useEffect(() => {
    const t = setTimeout(onClose, 8000);
    return () => clearTimeout(t);
  }, [onClose]);

  const winner = auction.winner_username || auction.highest_bidder_username;
  const isMe = winner && user && (Number(auction.highest_bidder_id) === Number(user.id) || winner === user.username);

  return (
    <div className="winner-overlay" onClick={onClose}>
      {winner && pieces.map(p => (
        <span
          key={p.id}
          className="confetti-piece"
          style={{
            left: `${p.left}%`,
            background: p.color,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            transform: `rotate(${p.rotate}deg)`
          }}
        />
      ))}
      <div className="winner-overlay-card" onClick={(e) => e.stopPropagation()}>
        {auction.jpeg_filename && (
          <img
            src={`${API_URL}/cards/${auction.jpeg_filename}`}
            alt={auction.name}
            className="winner-overlay-img"
          />
        )}
        <p className="winner-overlay-card-name">{auction.name}</p>
        {winner ? (
          <>
            <h1 className="winner-overlay-title">{isMe ? 'HAI VINTO!' : 'VINCITORE'}</h1>
            <p className="winner-overlay-name">{winner}</p>
            <p className="winner-overlay-bid">
              <span className="patapizza-icon"></span>
              {(auction.current_bid || 0).toLocaleString()} patapizze
            </p>
          </>
        ) : (
          <>
            <h1 className="winner-overlay-title muted">Asta chiusa</h1>
            <p className="winner-overlay-name">Nessun vincitore</p>
          </>
        )}
        <button className="btn btn-secondary" onClick={onClose}>Chiudi</button>
      </div>
    </div>
  );
}

export default AuctionWinnerOverlay;
